/** Wie ein Termin in der Oberflaeche steht -- F1-51 bis F1-54. */

import { DISPLAY_TIME_ZONE } from '../../i18n';
import { dayOf } from './dates';

/**
 * Der Zeitraum eines Termins: `Do., 24.09.2026, 10:00–11:30`.
 *
 * Ueber Mitternacht mit beiden Tagen -- `23:00–01:00` allein laese sich wie
 * ein Termin, der vor seinem Beginn endet.
 */
export function formatRange(startsAt: string, endsAt: string, language: string): string {
  const date = new Intl.DateTimeFormat(language, {
    weekday: 'short',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: DISPLAY_TIME_ZONE,
  });
  const time = new Intl.DateTimeFormat(language, {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: DISPLAY_TIME_ZONE,
  });
  const start = new Date(startsAt);
  const end = new Date(endsAt);

  if (dayOf(start) === dayOf(end)) {
    return `${date.format(start)}, ${time.format(start)}–${time.format(end)}`;
  }
  return `${date.format(start)}, ${time.format(start)} – ${date.format(end)}, ${time.format(end)}`;
}

/** Nur die Uhrzeiten -- wo der Tag schon darueber steht. */
export function formatTimes(startsAt: string, endsAt: string, language: string): string {
  const time = new Intl.DateTimeFormat(language, {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: DISPLAY_TIME_ZONE,
  });
  return `${time.format(new Date(startsAt))}–${time.format(new Date(endsAt))}`;
}

/** Ein Kalendertag als Ueberschrift: `Donnerstag, 24. September`. */
export function formatDayHeading(day: string, language: string): string {
  return new Intl.DateTimeFormat(language, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    timeZone: 'UTC',
  }).format(new Date(`${day}T12:00:00Z`));
}

/** Nur der Tag im Monat -- fuer die Zelle des Monatsrasters. */
export function formatDayNumber(day: string): string {
  return String(Number(day.slice(8, 10)));
}

/**
 * Tag und Monat -- fuer die Zelle der Woche: `21.09.`.
 *
 * Der Wochentag steht schon im Spaltenkopf; ausgeschrieben daneben brach
 * "Donnerstag, 24. September" in der Markierung fuer heute auf zwei Zeilen um.
 */
export function formatDayMonth(day: string, language: string): string {
  return new Intl.DateTimeFormat(language, {
    day: '2-digit',
    month: '2-digit',
    timeZone: 'UTC',
  }).format(new Date(`${day}T12:00:00Z`));
}

/** Der Zeitraum einer Ansicht: `September 2026` oder `21.–27.09.2026`. */
export function formatPeriod(
  first: string,
  last: string,
  month: boolean,
  language: string,
): string {
  if (month) {
    return new Intl.DateTimeFormat(language, {
      month: 'long',
      year: 'numeric',
      timeZone: 'UTC',
    }).format(new Date(`${first}T12:00:00Z`));
  }
  const format = new Intl.DateTimeFormat(language, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'UTC',
  });
  return format.formatRange(new Date(`${first}T12:00:00Z`), new Date(`${last}T12:00:00Z`));
}
